/* Watch Gallery ↔ EasySell COD Form
   1. Product cards: the app injects its popup button (.es-popup-button-product) into
      the card's add-to-cart form. The theme renders its own button (.wg-pc__cod-btn)
      and forwards clicks to the app's hidden one, so the app still resolves the
      product from the form it was injected into.
   2. Everywhere else (product page, sticky bar, cart drawer): the app's button
      arrives with inline !important colours. Those are removed and .wg-cod-btn is
      added so the theme's stylesheet can style it.
   3. Order popup: the app writes inline !important colours on the form container
      and the submit button. They are stripped so assets/wg-cod.css applies. */
(() => {
  const CARD = '.wg-pc';
  const APP_BUTTON = '.es-popup-button';
  const CARD_APP_BUTTON = '.es-popup-button-product';
  const THEME_TRIGGER = '[data-wg-cod-trigger]';
  const MODAL = '#easysell-modal';
  const STRIP_IN_MODAL = '#es-form-container, #es-form-button, #es-form-button *, .es-form-header .mb-2, #es-discount-button';

  // 1. Card trigger → app button in the same card
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(THEME_TRIGGER);
    if (!trigger) return;
    const card = trigger.closest(CARD);
    const appButton = card && card.querySelector(CARD_APP_BUTTON);
    event.preventDefault();
    event.stopPropagation();
    if (!appButton) return;
    appButton.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
  });

  // Keep only the app's own display toggle on an element, drop its colours/typography
  const keepDisplayOnly = (node) => {
    const style = node.getAttribute('style');
    if (style === null) return;
    const display = node.style.display;
    const next = display ? `display: ${display};` : '';
    if (next === style) return;
    if (next) node.setAttribute('style', next);
    else node.removeAttribute('style');
  };

  // 2. App buttons outside cards
  const themeAppButton = (button) => {
    if (button.closest(CARD)) return;
    if (!button.classList.contains('wg-cod-btn')) {
      button.classList.add('wg-cod-btn');
      if (!button.hasAttribute('tabindex')) button.setAttribute('tabindex', '0');
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          button.click();
        }
      });
    }
    const style = button.getAttribute('style') || '';
    if (/background|color|font|border|radius/i.test(style)) {
      // The app toggles pointer-events/opacity for sold-out products; keep those.
      const keep = [];
      if (button.style.pointerEvents) keep.push(`pointer-events: ${button.style.pointerEvents}`);
      if (button.style.opacity) keep.push(`opacity: ${button.style.opacity}`);
      if (button.style.display) keep.push(`display: ${button.style.display}`);
      if (keep.length) button.setAttribute('style', keep.join('; ') + ';');
      else button.removeAttribute('style');
    }
    button.querySelectorAll('[style]').forEach(keepDisplayOnly);
  };

  // 3. Popup: strip the inline colours the app writes on its form shell and CTA
  const stripModalStyles = (modal) => {
    modal.querySelectorAll(STRIP_IN_MODAL).forEach(keepDisplayOnly);
  };

  const scan = () => {
    document.querySelectorAll(APP_BUTTON).forEach(themeAppButton);
    const modal = document.querySelector(MODAL);
    if (modal) stripModalStyles(modal);
  };

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan();
    });
  };

  const start = () => {
    scan();
    new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === 'childList') {
          if (record.addedNodes.length) {
            schedule();
            return;
          }
          continue;
        }
        const target = record.target;
        if (!(target instanceof Element)) continue;
        if (target.closest(MODAL) || (target.matches(APP_BUTTON) && !target.closest(CARD))) {
          schedule();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
